import { render, staticRenderFns } from "./commercialProject.vue?vue&type=template&id=2c3eea26&scoped=true&"
import script from "./commercialProject.vue?vue&type=script&lang=js&"
export * from "./commercialProject.vue?vue&type=script&lang=js&"
import style0 from "./commercialProject.vue?vue&type=style&index=0&id=2c3eea26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3eea26",
  null
  
)

export default component.exports